import { useRef, useCallback } from "react";

/**
 * 延遲呼叫函式(文字輸入延遲呼叫內容)
 * @param callback 被 debounce 的 callback
 * @param delay 延遲毫秒
 */
const useDebouncedCallback = (callback, delay) => {
    const timer = useRef();
    
    const debouncedFn = useCallback((...args) => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);
    
    return debouncedFn;
};

export default useDebouncedCallback;